import React, { useRef, useState, MouseEvent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUnixTime } from 'date-fns';


import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from "@mui/material/Button";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import Grow from '@mui/material/Grow';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { ArrowForward, LockOutlined, Visibility, VisibilityOff } from '@mui/icons-material';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { FormProvider, useForm } from "react-hook-form";

import { isFalsy } from 'utility-types';

import { Language as LanguageIcon, TranslateOutlined as TranslateOutlinedIcon, } from '@mui/icons-material';

import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

import ReCAPTCHA from 'react-google-recaptcha';

import { ThreeDots } from 'react-loader-spinner';
import { IUserCredential, IUserSession } from 'features/identity/models/User';

import useIdentityUserService from 'features/identity/services/User';

import useApplicationSetupService from 'features/setup/services/ApplicationSetup';

import useAxios from 'library/axios';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import { useLocalStorage } from 'react-use';
import { currentUserSessionAtom, colorsAtom, hubConnectionIdAtom, lastUnixTimeStampAtom, useSideBarMenuAtom, currentFormNameAtom, isSaveLoadingAtom }
    from 'library/store';
import md5 from 'md5';
import { IResult } from 'library/interface';

import __axios from "axios";

import { globalConfig } from 'config';
import useVisibilityToggle from 'library/useVisibilityToggle';

import { defaultAppTheme } from 'themes/commonStyles';
import { CircularProgress, InputAdornment } from '@mui/material';


import AuthCardWrapper from "./AuthCardWrapper";



const SingInForm = () => {
    const axios = useAxios();

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const [currentUserSession, setCurrentUserSession] = useRecoilState(currentUserSessionAtom);
    // const { language, userName, isPasswordComplexityAllowed } = useRecoilValue(currentUserSessionAtom);

    const [currentFormName, setCurrentFormNameAtom] = useRecoilState(currentFormNameAtom);
    const [isSaveLoading, setIsSaveLoading] = useRecoilState(isSaveLoadingAtom);

    const [storeLanguage, setStoreLanguage, removeStoreLanguage] = useLocalStorage('Language');
    const [storeTenant, setStoreTenant, removeStoreTenant] = useLocalStorage<string>("Tenant");

    // const formSchema = yup.object().shape({
    //   newPassword: yup.string()
    //     .required('Password is mendatory')
    //     .min(3, 'Password must be at 3 char long'),
    //     confirmNewPassword: yup.string()
    //     .required('Password is mendatory')
    //     .oneOf([yup.ref('password')], 'Passwords does not match'),
    // })

    const methods = useForm<IUserCredential>({ defaultValues: { language: 'fr', userName: '', password: '' } });
    const { register, getValues, setValue, formState: { errors, isSubmitting } } = methods;

    const userNameRegister = register("userName");

    const [hubConnectionId, setHubConnectionId] = useRecoilState(hubConnectionIdAtom);

    /** Message d'échec affiché dans la carte. Une notification de 2 s disparaissait avant
    *  d'etre lue — et sur un ecran de connexion, savoir POURQUOI ca a echoue est l'essentiel. */
    const [authError, setAuthError] = useState<string>('');


    const postCredential = async (credential: IUserCredential) =>
        await (await axios.post('/api/identity/token/username-exists', { ...credential })).data;

    const { isLoading, isError, isSuccess, error, mutate } = useMutation<IResult<boolean>, Error, IUserCredential>({
        mutationFn: postCredential,
        onSuccess: (data: IResult<boolean>, variables: IUserCredential) => {

            if (!data.succeeded) {
                enqueueSnackbar(data.messages.join('\n'), {
                    variant: 'error',
                    anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
                });
                return;
            }

            if (!data.data) {
                enqueueSnackbar(t('Invalid user credential'), {
                    variant: 'error',
                    anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
                });
                return;
            }

            const { userName } = variables;

            setCurrentUserSession({ ...currentUserSession, userName, isUsernameValid: true });
            navigate({ pathname: `/pwd` });
        },
        onError: (err: Error) => {
            setIsSaveLoading(false);
            enqueueSnackbar(error?.message, {
                variant: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" }, autoHideDuration: 2000,
            });

        },
    });

    const postLogin = async (event: MouseEvent<HTMLButtonElement>) => {

        event.preventDefault();

        if (isLoading) return;

        setAuthError('');

        const { userName, password, language } = getValues();

        const { hostname, host } = window.location;

        const tempTenant = window.location.search.replace('?', '');
        //const tenantAlias =  host.split('.')[0];
        const tenantAlias = !isFalsy(tempTenant) ? tempTenant :
            !isFalsy(storeTenant) ? storeTenant : globalConfig.get().defaultTenant;

        if (tenantAlias === '') {

            enqueueSnackbar(t('The url is invalid, you have to add ?xxxx at the of url'), {
                variant: 'error',
                anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
            });

            const tenant = 'xxxx';
            window.location.replace(`${host}?${tenant}`);
            return;
        }

        setStoreTenant(tenantAlias);

        mutate({ userName, password: md5(password), language, tenantAlias, hubConnectionId });

        //mutate({ userName, password: CryptoJS.MD5(password).toString(CryptoJS.enc.Hex), language, tenantAlias, hubConnectionId });

    };

    //const refUserName = useRef<HTMLInputElement>(null);
    const refUserName = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        const sync = () => {
            const domValue = refUserName.current?.value ?? "";

            if (domValue && domValue !== getValues("userName")) {
                setValue("userName", domValue, {
                    shouldDirty: true,
                    shouldValidate: true
                });
            }
        };

        sync();

        const timers = [100, 300, 700, 1200].map(delay =>
            window.setTimeout(sync, delay)
        );

        return () => timers.forEach(clearTimeout);
    }, [getValues, setValue]);

    return (
        <AuthCardWrapper
            title={t('Signin')}
            description={t("signInDescription")}
        >
            <FormProvider {...methods}>
                <Box
                    sx={{
                        paddingY: 1,

                        width: "100%",
                    }}
                >
                    <TextField
                        type="email"
                        //placeholder="example@email.com"
                        label={t("Username")}
                        sx={{
                            width: "100%",
                        }}
                        error={!!errors.userName}
                        helperText={errors.userName?.message as string | undefined}
                        {...userNameRegister}
                        inputRef={(element: HTMLInputElement | null) => {
                            userNameRegister.ref(element);
                            refUserName.current = element;
                        }}
                        inputProps={{ autoComplete: 'username', style: { textTransform: 'none' } }}
                        InputProps={{
                            onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
                                if (event.key === "Enter") {
                                    const postLogin = document.getElementById("postLogin");
                                    postLogin?.click();
                                }
                            },
                        }}

                    />
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Button
                        id="postLogin"
                        type="submit"
                        variant="contained"
                        onClick={postLogin}
                        disabled={isLoading}
                        endIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <ArrowForward />}
                        sx={{
                            width: "100%",
                            padding: 1.5,
                            mt: 2,
                        }}
                    >
                        {isLoading ? `${t('Continue')}...` : t('Continue')}
                    </Button>
                    <Box
                        sx={{
                            marginY: 1.3,
                        }}
                    >
                        {t('forgotPassword')}{" "}
                        <Typography
                            component="a"
                            href="/auth/forgot-password"
                            onClick={() => navigate({ pathname: '/forgot-password', search: window.location.search })}
                            sx={{ color: (theme) => theme.palette.primary.main, fontWeight: 600, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
                        >
                            {t('recoverLink')}
                        </Typography>
                    </Box>
                </Box>
            </FormProvider>
        </AuthCardWrapper>
    );
};

export default SingInForm;